"use client";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Pagination } from "./Pagination";
import { Download } from "lucide-react";

interface DriverTransactionsTableProps {
  transactions: DriverTransaction[];
  page: number;
  totalPages: number;
}

const DriverTransactionsTable = ({
  transactions,
  page,
  totalPages,
}: DriverTransactionsTableProps) => {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full overflow-x-auto">
        <Table>
          <TableHeader className="bg-[#f9fafb]">
            <TableRow>
              <TableHead className="px-2 whitespace-nowrap">Date</TableHead>
              <TableHead className="px-2 hidden sm:table-cell">Type</TableHead>
              <TableHead className="px-2">Montant</TableHead>
              <TableHead className="px-2 text-right">Facture</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {/* Transaction Rows */}
            {transactions.map((transaction) => (
              <TableRow key={transaction.course_id}>
                <TableCell className="px-2">
                  <div className="text-14 text-[#344054] whitespace-nowrap">
                    {transaction.date}
                  </div>
                </TableCell>
                <TableCell className="px-2 hidden sm:table-cell">
                  <div className="text-14 text-[#344054]">{transaction.type}</div>
                </TableCell>
                <TableCell className="px-2">
                  <div className="text-14 text-green-600 font-medium">
                    {transaction.amount_display}
                  </div>
                </TableCell>
                <TableCell className="px-2 text-right">
                  {transaction.bill_url ? (
                    <a
                      href={transaction.bill_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-end text-blue-600 hover:text-blue-800"
                    >
                      <Download className="h-4 w-4" />
                    </a>
                  ) : (
                    <div className="text-14 text-[#344054]">—</div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Pagination page={page} totalPages={totalPages} />
    </div>
  );
};

export default DriverTransactionsTable;

